import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAnalytics from "storefront/hooks/useAnalytics";
import type { From } from "storefront/Analytics/EventCreators/productAddedToWishlist";
import type { User, FollowedListings } from "storefront/User";
import {
  addToFittingRoom,
  removeFromFittingRoom,
} from "storefront/actions/fittingRoomActions";
import type { GlobalState } from "storefront/GlobalState";
import type { AlgoliaInstantSearchListing } from "storefront/components/FiltersInstantSearch/CustomInfiniteHits/NonEmpty";
import "storefront/components/FiltersInstantSearch/CustomInfiniteHits/NonEmpty";
import type { LegacyListing } from "storefront/Listing";
import "storefront/Listing";

const followedListingsSelector = (state: GlobalState): FollowedListings =>
  state.session.currentUser.followedListings || [];

type ValueAndSetter = [boolean, (arg0: User) => void];

const useIsFavorited = (
  listing: LegacyListing | AlgoliaInstantSearchListing,
  from: From | null | undefined,
): ValueAndSetter => {
  const dispatch = useDispatch();
  const followedListings = useSelector(followedListingsSelector);
  const { track } = useAnalytics();
  const [isFavorited, setIsFavorited] = useState<boolean>(false);
  useEffect(() => {
    if (followedListings.includes(listing.id)) {
      setIsFavorited(true);
    }
  }, [followedListings, listing.id]);

  const toggleIsFavorited = (currentUser: User) => {
    if (isFavorited) {
      setIsFavorited(false);
      dispatch(
        removeFromFittingRoom(currentUser.id, listing, track, from),
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'From | null | undefined' is not ... Remove this comment to see the full error message
      ).catch(() => {
        setIsFavorited(true);
      });
    } else {
      setIsFavorited(true);
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'From | null | undefined' is not ... Remove this comment to see the full error message
      dispatch(addToFittingRoom(currentUser.id, track, listing, from)).catch(
        () => {
          setIsFavorited(false);
        },
      );
    }
  };

  return [isFavorited, toggleIsFavorited];
};

export default useIsFavorited;
